export default __webpack_public_path__ + "static/media/Untitled2.d5698212.jpg";